import { medal_getById_Api } from 'apis'
import { withProps } from 'recompose'
import { FetchEntityById } from 'views/Shared/components/FetchEntityById'

const FetchMedalById = withProps({
  apiInfo: medal_getById_Api,
})(FetchEntityById)

export default FetchMedalById
